export const ERROR = 'This feature only allows access to signed-in users';
